import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _LegacyChoiceType;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import t from '@instructure/quiz-i18n/es/format-message';
import { Table } from '@instructure/ui-table';
import { jsx } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import PropTypes from 'prop-types';
import ChoiceTypeTableRow from './ChoiceTypeTableRow';
import { choiceTypeAnswerSummaryPropType } from '../../../common/propTypes';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import AfsTableWrapper from '../shared/AfsTableWrapper';
import { withStyleOverrides } from '@instructure/quiz-common';
export var LegacyChoiceType = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_LegacyChoiceType = /*#__PURE__*/function (_Component) {
  function LegacyChoiceType() {
    var _this;
    _classCallCheck(this, LegacyChoiceType);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LegacyChoiceType, [].concat(args));
    _defineProperty(_this, "renderRow", function (choice, choiceIndex) {
      return jsx(ChoiceTypeTableRow, {
        key: choiceIndex,
        choice: choice,
        choiceIndex: choiceIndex
      });
    });
    _defineProperty(_this, "renderNoAnswer", function (payload, choiceIndex) {
      var asChoice = {
        body: t('(No answer)'),
        percentage: payload.percentage,
        correct: false,
        count: payload.count
      };
      return jsx(ChoiceTypeTableRow, {
        key: choiceIndex,
        choice: asChoice,
        choiceIndex: choiceIndex
      });
    });
    return _this;
  }
  _inherits(LegacyChoiceType, _Component);
  return _createClass(LegacyChoiceType, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        answerSummary = _this$props.answerSummary,
        itemId = _this$props.itemId;
      var choices = answerSummary.choices,
        noAnswer = answerSummary.no_answer;
      var numberOfChoices = choices.length;
      var spacingHeaderId = "answer-frequency-summary-spacing-".concat(itemId);
      var answerHeaderId = "answer-frequency-summary-answer-".concat(itemId);
      var respondentsHeaderId = "answer-frequency-summary-respondents-".concat(itemId);
      var percentageHeaderId = "answer-frequency-summary-percentage-".concat(itemId);
      return jsx(AfsTableWrapper, null, jsx("div", {
        css: this.props.styles.tableContainer
      }, jsx(Table, {
        caption: t('Answer Frequency Summary')
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: spacingHeaderId,
        width: "46px"
      }, jsx(ScreenReaderContent, null, t('Answer correctness'))), jsx(Table.ColHeader, {
        id: answerHeaderId,
        height: "47px"
      }, t('Answer')), jsx(Table.ColHeader, {
        id: respondentsHeaderId,
        height: "47px"
      }, t('Respondents')), jsx(Table.ColHeader, {
        id: percentageHeaderId,
        height: "47px",
        textAlign: "center"
      }, t('Percentage')))), jsx(Table.Body, null, choices.map(this.renderRow), this.renderNoAnswer(noAnswer, numberOfChoices)))));
    }
  }]);
}(Component), _defineProperty(_LegacyChoiceType, "displayName", 'LegacyChoiceType'), _defineProperty(_LegacyChoiceType, "componentId", "Quizzes".concat(_LegacyChoiceType.displayName)), _defineProperty(_LegacyChoiceType, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: choiceTypeAnswerSummaryPropType.isRequired,
  styles: PropTypes.object
}), _LegacyChoiceType)) || _class);